import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

export const useAddContentToTextSet = () => {
  const addTextSetContent = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/content-membership/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(addTextSetContent);
};

export default useAddContentToTextSet;
